import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from '../ui';

import {
  increaseStepByOne,
  showError
} from "../../actions";

const styles = {
  container: {
    margin: 0,
    marginTop: '35px',
    textAlign: 'right',
  },
  click: {
    display: 'inline-flex',
    borderRadius: '100px'
  }
  
}

class Continue extends Component {

  onContinue = () => {
    const {
      state, onClick,
      onContinueClick,
      showError
    } = this.props;
    if(state) {
     onContinueClick();
     if(onClick !== null) onClick();
    } else {
      showError(true);
    }
  }

  render() {
    const { text, state } = this.props;
    return (
      <div style={styles.container}>
        <div style={styles.click} onClick={this.onContinue}>
          <Button
            style={{cursor: 'pointer'}}
            disabled={!state}
          >
            {text}
          </Button>
        </div>
      </div>
    );
  }
}

Continue.defaultProps = {
  state: false,
  text: 'Continuar',
  onClick: null
};

const mapDispatchToProps = dispatch => {
  return {
    onContinueClick: () => {
      dispatch(increaseStepByOne());
    },
    showError: (show) => {
      dispatch(showError(show));
    },
  };
};

export default connect(null, mapDispatchToProps)(Continue);